<template>
  <div class="pb-3" >
    <va-card :title="$t(`weeks.cards.${titleCard}`) + ' - ' + 'Grupo ' + this.weekGroup">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Nome" v-slot="{ errors }">
                <va-input
                  v-model="week.name"
                  :label="$t('weeks.forms.nameLabel')"
                  :placeholder="$t('weeks.forms.namePlaceholder')"
                  :success="errors.length == 0 && week.name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider v-if="updateData !== null" rules="required" name="Grupo" v-slot="{ errors }">
                <va-select
                  :label="$t('weeks.forms.groupLabel')"
                  v-model="selectedWeekGroup"
                  textBy="name"
                  searchable
                  :placeholder="$t('weeks.forms.group')"
                  :noOptionsText="$t('weeks.forms.noGroup')"
                  maxHeight='200px'
                  :options="weekGroupsList.length > 0 ? weekGroupsList : []"
                  :error="errors.length > 0"
                  :messages="errors"
                />
              </ValidationProvider>
              <va-toggle
                v-model="week.active"
                small
                :label="$t('weeks.forms.activeLabel')"
              />
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'WeeksAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
    weekGroup: {
      required: true,
    },
  },
  data () {
    return {
      week: {
        name: '',
        active: false,
      },
      logo: [],
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
      weekGroupsList: [],
      selectedWeekGroup: '',
    }
  },
  apollo: {
    weekGroups: {
      query: gql`
      query myquery {
        week_groups: week_group(order_by: {id: asc}) {
          id
          name
        }
      }
    `,
      result ({ data }) {
        this.weekGroupsList = data.week_groups
        if (data.week_groups.length > 0 && this.selectedWeekGroup === '') {
          this.selectedWeekGroup = Object.assign({}, data.week_groups[0])
        }
      },
    },
  },
  created () {
    this.week.name = ''
    if (this.updateData !== null) {
      this.week_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (value !== null) {
        this.week_get(value)
        if (this.weekGroupsList.length) {
          this.selectedWeekGroup = this.weekGroupsList.find(
            g => g.id === value.week_group_id,
          )
        }
      }
    },
    weekGroupsList (list) {
      if (this.updateData && list.length) {
        this.selectedWeekGroup = list.find(
          g => g.id === this.updateData.week_group_id,
        )
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    week_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          this.week[value] = data[value]
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { name, active } = this.week
      const self = this
      const updateAll = `update_week(_set: {active: false}, where: {id: {_gte: 0}}) {
        affected_rows
      }`
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($name: String!, $active: Boolean, $id: Int!, $weekGroupId: Int!) {
                  ${active === true ? updateAll : ''}
                  update_week_by_pk(pk_columns: {id: $id}, _set: {name: $name, active: $active, week_group_id: $weekGroupId}) {
                    id
                  }
                }
                ` : gql`
                mutation MyMutation($name: String, $active: Boolean, $weekGroupId: Int!) {
                  ${active === true ? updateAll : ''}
                  insert_week(objects: {name: $name, active: $active, week_group_id: $weekGroupId}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            name,
            active,
            id: this.week.id,
            weekGroupId: this.selectedWeekGroup?.id,
          } : {
            name,
            active,
            weekGroupId: this.weekGroup,
          }
          ,
        })
        .then(data => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.week.name = ''
          self.$emit('showAdd', false)
          self.$emit('showMore', self.page)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.submit')
          self.week.name = ''
          self.$emit('showAdd', false)
          self.showToast(
            self.$t(
              self.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style lang="scss">
.va-message-list {
  &__message {
    vertical-align: middle;
    font-size: $font-size-mini;
    color: rgb(248, 112, 109);
  }
}

.position {
  position: relative;
}
</style>
